/**
 * 미리 만들어 둔 설명서·소개서 파일.
 *
 * **`npm run docs` 가 적는다 — 손으로 고치지 않는다.** 콘솔은 이 목록을 보고 주소를
 * 지어 걸어 두기만 하고, 누르면 서버에 있는 파일이 그대로 내려간다(예전에는 누를 때마다
 * 브라우저가 문서를 지었다).
 *
 * 파일은 `public/downloads/` 에 **이름 그대로** 있다. 번들러가 해시를 붙이면 판마다 주소가
 * 바뀌어, 배포 전에 열어 둔 탭이 옛 파일을 계속 받는다.
 *
 * 종류마다 현재 판과 **이전 판**을 남긴다 — 새 판을 낸 뒤 "전에 보내 드린 것" 을 다시
 * 찾는 일이 있고, 새 판에 문제가 있으면 되돌릴 자리가 필요하다.
 *
 * `source` 는 그 판을 만든 `src/manual` 의 지문이다. 설명서를 고치고 다시 굽지 않으면
 * 시험(`downloads.test.ts`)이 이 값으로 잡는다.
 */

/** 파일이 놓이는 자리 — 빌드 base 뒤에 이 경로를 붙이면 주소가 된다. */
export const DOWNLOAD_DIR = 'downloads';

export interface DownloadEntry {
  /** 디스크와 주소에 같이 쓰는 이름. 시험이 이것으로 파일을 찾는다. */
  file: string;
  bytes: number;
  /** 받는 사람에게 보일 이름. 디스크 이름은 아스키, 보이는 이름은 한글이다. */
  name: string;
  extension: string;
}

export interface DownloadSet {
  builtAt: string;
  source: string;
  files: Record<string, DownloadEntry>;
}

export const DOWNLOADS: { current: DownloadSet; previous: DownloadSet | null } = {
  current: {
  builtAt: '2026-11-04',
  source: '6e2b9b7b93ea96b0',
  files: {
    'manual-pdf': { file: 'manual.pdf', bytes: 6168803, name: '사용설명서', extension: 'pdf' },
    'manual-pptx': { file: 'manual.pptx', bytes: 18720733, name: '사용설명서', extension: 'pptx' },
    'overview-pdf': { file: 'overview.pdf', bytes: 554610, name: '시스템소개서', extension: 'pdf' },
    'overview-pptx': { file: 'overview.pptx', bytes: 1146303, name: '시스템소개서', extension: 'pptx' },
  } as Record<string, DownloadEntry>,
},
  /** 이전 판 — 처음 구운 뒤 한 번도 안 바뀌었으면 없다. */
  previous: {
  builtAt: '2026-11-04',
  source: '7b213b3dbbf01ede',
  files: {
    'manual-pdf': { file: 'manual.prev.pdf', bytes: 6166686, name: '사용설명서', extension: 'pdf' },
    'manual-pptx': { file: 'manual.prev.pptx', bytes: 18709962, name: '사용설명서', extension: 'pptx' },
    'overview-pdf': { file: 'overview.prev.pdf', bytes: 554618, name: '시스템소개서', extension: 'pdf' },
    'overview-pptx': { file: 'overview.prev.pptx', bytes: 1146303, name: '시스템소개서', extension: 'pptx' },
  } as Record<string, DownloadEntry>,
},
};
